// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class ActualsProjectProductBreakdownSummary {
  readonly id: string;
  readonly name: string;
  readonly projectId: string;
  readonly productId: string;
  readonly category: Enums.ProductCategory;
  readonly variance: string | null;
  readonly quotedVolume: string | null;
  readonly deliveredVolume: string | null;
  readonly percentageOfTotalDeliveredVolume: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.projectId = data.projectId === undefined ? NIL_UUID : data.projectId;
    this.productId = data.productId === undefined ? NIL_UUID : data.productId;
    this.category = data.category === undefined ? Enums.ProductCategory.ReadyMix : data.category;
    this.variance = data.variance === undefined ? null : data.variance;
    this.quotedVolume = data.quotedVolume === undefined ? null : data.quotedVolume;
    this.deliveredVolume = data.deliveredVolume === undefined ? null : data.deliveredVolume;
    this.percentageOfTotalDeliveredVolume =
      data.percentageOfTotalDeliveredVolume === undefined
        ? null
        : data.percentageOfTotalDeliveredVolume;
  }

  static zero(): ActualsProjectProductBreakdownSummary {
    const zeroValues: ExcludeMethodsDeep<ActualsProjectProductBreakdownSummary> = {
      id: NIL_UUID,
      name: '',
      projectId: NIL_UUID,
      productId: NIL_UUID,
      category: Enums.ProductCategory.ReadyMix,
      variance: null,
      quotedVolume: null,
      deliveredVolume: null,
      percentageOfTotalDeliveredVolume: null,
    };
    return new ActualsProjectProductBreakdownSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ActualsProjectProductBreakdownSummaryWireFormat = {
  id: string;
  name: string;
  projectId: string;
  productId: string;
  category: string;
  variance: string | null;
  quotedVolume: string | null;
  deliveredVolume: string | null;
  percentageOfTotalDeliveredVolume: string | null;
};

type NewActualsProjectProductBreakdownSummaryProps = PartialDeep<
  ActualsProjectProductBreakdownSummary,
  { recurseIntoArrays: true }
>;
export const NewActualsProjectProductBreakdownSummary: (
  props: NewActualsProjectProductBreakdownSummaryProps,
) => ActualsProjectProductBreakdownSummary = (props) =>
  new ActualsProjectProductBreakdownSummary(props);

type NewActualsProjectProductBreakdownSummaryFromWireFormatProps = PartialDeep<
  ActualsProjectProductBreakdownSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewActualsProjectProductBreakdownSummaryFromWireFormat: (
  props: NewActualsProjectProductBreakdownSummaryFromWireFormatProps,
) => ActualsProjectProductBreakdownSummary = (props) =>
  new ActualsProjectProductBreakdownSummary(props);
